// extracted by mini-css-extract-plugin
module.exports = {"infoIconStyle":"BookedSessionStyles_infoIconStyle__ImHlh"};